import { render, staticRenderFns } from "./shareC.vue?vue&type=template&id=8ebe6580&scoped=true&"
import script from "./shareC.vue?vue&type=script&lang=js&"
export * from "./shareC.vue?vue&type=script&lang=js&"
import style0 from "./shareC.vue?vue&type=style&index=0&id=8ebe6580&scoped=true&lang=scss&"
import style1 from "./shareC.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebe6580",
  null
  
)

export default component.exports